export const DECIMAL_PATTERN = /^\d{1,8}(\.\d{0,2})?$/
export const LEADING_ZEROS_PATTERN = /^0+(?=[\d.])/
